import { useEffect, useRef, useState, ReactNode } from 'react';

interface LazyWrapperProps {
  children: ReactNode;
  minHeight?: string;
  rootMargin?: string;
}

const LazyClientWrapper = ({ children, minHeight = '300px', rootMargin = '300px' }: LazyWrapperProps) => {
  const [inView, setInView] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Se por milagre o browser não suportar, renderizamos
    if (typeof window === 'undefined' || !window.IntersectionObserver) {
      setInView(true);
      return;
    }
    
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} style={{ minHeight: inView ? 'auto' : minHeight, width: '100%' }}>
      {inView ? children : null}
    </div>
  );
};

export default LazyClientWrapper;
